import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { SevenFever_Responsive } from "../SevenFever/game_responsive";
export class SevenFeverLink_Responsive extends SevenFever_Responsive {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "SevenFeverLink");
    }

}